import React from 'react';
import { FormControl, FormLabel } from '@mui/material';
import { AdminLedgerPicker } from '../../shared/pickers/AdminLedgerPicker';
import { AdminCountryPicker } from '../../shared/pickers/AdminCountryPicker';

const FILTERS = [
	{ field: 'ledger', label: 'Ledger', Picker: AdminLedgerPicker },
	{ field: 'countryCode', label: 'Country', Picker: AdminCountryPicker },
];

/**
 * The broker groups table's filters, one element per filter for AdminListToolbar (see
 * useBrokerGroupFilter). Each has "All" and "Clear Filter" options. Values are saved in the
 * admin table prefs through useAdminListParams' filters / setFilter.
 */
export const getBrokerGroupFilters = ({ filters, setFilter }) =>
	FILTERS.map(({ field, label, Picker }) => (
		<FormControl key={field} fullWidth>
			<FormLabel>{label}</FormLabel>
			<Picker
				value={filters[field] ?? []}
				onChange={(values) => setFilter(field, values.length ? values : undefined)}
				showCheckbox
				showAllOption
				showClearOption
			/>
		</FormControl>
	));
